import { INFORM_HOST } from 'modules/root/Settings/envVars';

export const handleViewInformApplication = (
  formBundleId: string | null | undefined
): void => {
  window.open(`${INFORM_HOST}/#/loanOriginationSystem/newForm/${formBundleId}`, '_blank');
};
